import React from "react";
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Styles = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  img {
    position: absolute;
    right 0;
    bottom: 0;
  }
  h1 {
    font-size: 140px;
    font-weight: 900;
    color: #001529;
    margin-bottom: 6px;
  }
  p {
    font-size: 18px;
    color: #001529;
    opacity: 0.5;
  }
`;

export default function NotFound() {
  const { t } = useTranslation();
  return <Styles>
    <h1>404</h1>
    <p>{t('The page you are looking for does not exist')}</p>
    <img src="/assets/images/SVG/404.svg" alt="not-found" />
  </Styles>;
}
